import { t } from "i18next";
import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import FormWrapper from "@app/components/FormWrapper";
import VersionManagementForm from "@app/components/forms/VersionManagement.form";
import { RoutePaths } from "@app/routes/index";
import { updateVersion } from "@app/services/Endpoints/VersionControl.API";
import { ModalType } from "@app/types/Common.types";
import { VersionControlData } from "@app/types/VersionControl";
import { FormContext } from "@app/utils/contexts/Form.context";

interface VersionContainerProps {
    version?: VersionControlData;
}

const VersionManagementContainer: FC<VersionContainerProps> = ({ version }) => {
    const navigate = useNavigate();

    const [editFormData, setEditFormData] = useState({
        nextVersion: "",
        expiryDate: "",
        isActive: false,
    });
    const { triggerShowModal, setActions, isDirty, setIsDirty } = useContext(FormContext);
    const handleUpdateVersion = () => {
        const tempObj = {
            branchId: version?.branchId ?? "",
            versionId: editFormData.nextVersion,
            expiryDate: editFormData.expiryDate,
            isActive: editFormData.isActive,
            status: "Pending",
        };
        updateVersion({ ...tempObj })
            .then(() => {
                triggerShowModal(false, ModalType.SUBMIT);
                navigate(RoutePaths.ViewVersionManagement);
                setIsDirty(false);
            })
            .catch((err) => {
                triggerShowModal(false, ModalType.SUBMIT);
                console.log(err);
            });
    };

    const handleCancel = () => {
        if (isDirty) {
            triggerShowModal(true, ModalType.CANCEL);
            setActions({
                done: () => {
                    navigate(-1);
                    triggerShowModal(false, ModalType.CANCEL);
                    setIsDirty(false);
                },
                cancel: () => {
                    triggerShowModal(false, ModalType.CANCEL);
                },
            });
        } else navigate(RoutePaths.ViewVersionManagement);
    };

    const handleSubmit = () => {
        triggerShowModal(true, ModalType.SUBMIT);
        setActions({
            done: () => handleUpdateVersion(),
            cancel: () => triggerShowModal(false, ModalType.SUBMIT),
        });
    };

    const handleChange = (name: string, value: string | boolean) => {
        setEditFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
        setIsDirty(true);
    };
    useEffect(() => {
        if (version) {
            setEditFormData({
                nextVersion: version?.upcomingVersion ?? "",
                expiryDate: version?.expiryDate ?? "",
                isActive: version?.isActive ?? false,
            });
        }
    }, [version]);

    return (
        <FormWrapper
            heading={t("VERSION_MANAGEMENT.EDIT.EDIT_HEADING.LABEL")}
            onCancelClick={handleCancel}
            onSubmitClick={handleSubmit}
            submitDisabled={!isDirty}
            noteSection={true}
            noteText={t("VERSION_MANAGEMENT.EDIT.NOTE_TEXT.LABEL") as string}
        >
            <VersionManagementForm
                version={version}
                nextVersion={
                    version?.nextAvailableVersions?.map(({ id, name }) => ({
                        value: id,
                        label: name,
                    })) ?? []
                }
                editFormData={editFormData}
                onChange={handleChange}
            />
        </FormWrapper>
    );
};
export default VersionManagementContainer;
